import { Link } from "react-router-dom";
import { SocialIcons } from "@/components/Social";

export default function Footer() {
  return (
    <footer className="border-t border-neutral-200/60 bg-cream mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Offline & Available" className="h-14 w-14 rounded-full object-cover" />
            <div className="font-heading text-2xl">Offline &amp; Available</div>
          </div>
          <p className="text-neutral-600 mt-4 max-w-md leading-relaxed">An event brand for adults — speed dating, themed parties, couples nights, game nights, holiday events, and social experiences worth showing up for.</p>
          <div className="mt-6"><SocialIcons size={20} /></div>
        </div>
        <div className="md:col-span-3">
          <div className="text-eyebrow mb-4">Events</div>
          <ul className="space-y-1 text-neutral-700 text-sm">
            <li><Link to="/events?category=Special" className="block py-1.5 hover:text-black underline underline-offset-4" data-testid="footer-cat-special">Themed &amp; seasonal</Link></li>
            <li><Link to="/events?category=Friends" className="block py-1.5 hover:text-black underline underline-offset-4" data-testid="footer-cat-friends">Social nights</Link></li>
            <li><Link to="/events?category=Couples" className="block py-1.5 hover:text-black underline underline-offset-4" data-testid="footer-cat-couples">Couples</Link></li>
            <li><Link to="/events?category=Singles" className="block py-1.5 hover:text-black underline underline-offset-4" data-testid="footer-cat-singles">Singles &amp; dating</Link></li>
            <li><Link to="/events" className="block py-1.5 hover:text-black underline underline-offset-4" data-testid="footer-schedule">Full schedule</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="text-eyebrow mb-4">Stay connected</div>
          <p className="text-neutral-600 text-sm leading-relaxed">Follow along on Instagram, Facebook, and TikTok for the latest events, ticket releases, and announcements.</p>
          <div className="mt-4"><SocialIcons size={20} gap="gap-5" /></div>
          <div className="mt-6 flex flex-col gap-1 text-sm">
            <Link to="/contact" className="block py-1.5 hover:text-black underline underline-offset-4" data-testid="footer-contact-cta">Get in touch →</Link>
            <Link to="/safety" className="block py-1.5 hover:text-black underline underline-offset-4" data-testid="footer-safety-cta">Trust &amp; safety →</Link>
            <Link to="/faq" className="block py-1.5 hover:text-black underline underline-offset-4" data-testid="footer-faq-cta">FAQ →</Link>
            <Link to="/terms" className="block py-1.5 hover:text-black underline underline-offset-4" data-testid="footer-terms-cta">Terms &amp; Conditions →</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-neutral-200/60 py-6 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} Offline &amp; Available · Experiences worth showing up for.
      </div>
    </footer>
  );
}
